<button mat-raised-button (click)="consoleLogDocuments()">Console Log Documents</button>
